import script from "./InspectionPhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionPhoto.vue?vue&type=script&setup=true&lang=js"

import "./InspectionPhoto.vue?vue&type=style&index=0&id=679e387e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-679e387e"]])

export default __exports__